// Version Manager for cache busting
import { APP_VERSION } from "../version";

export class VersionManager {
  constructor() {
    this.currentVersion = this.getCurrentVersion();
    this.storageKey = "app_version";
  }

  // Get current version from the generated version file
  getCurrentVersion() {
    try {
      // Import version from version.js file
      return APP_VERSION || Date.now().toString();
    } catch (error) {
      return Date.now().toString();
    }
  }

  // Check if app version has changed (indicating an update)
  hasVersionChanged() {
    const storedVersion = localStorage.getItem(this.storageKey);
    const currentVersion = this.currentVersion;

    if (storedVersion !== currentVersion) {
      // Update stored version
      localStorage.setItem(this.storageKey, currentVersion);
      return true;
    }

    return false;
  }

  // Force refresh the page
  forceRefresh() {
    window.location.reload();
  }

  // Check for updates and refresh if needed
  checkForUpdates() {
    if (this.hasVersionChanged()) {
      console.log("App version changed, refreshing...");
      this.forceRefresh();
      return true;
    }
    return false;
  }

  // Get version info for debugging
  getVersionInfo() {
    return {
      currentVersion: this.currentVersion,
      storedVersion: localStorage.getItem(this.storageKey),
      hasChanged: this.hasVersionChanged(),
    };
  }

  // Manual version update (useful for testing)
  updateVersion(newVersion) {
    localStorage.setItem(this.storageKey, newVersion);
  }
}

// Create singleton instance
export const versionManager = new VersionManager();
